var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickandarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 23,
    viewBox: "0 0 47 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.7692L5.16216 15L15 5",
    stroke: "#27D639",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 11.5,
    r: 11,
    stroke: "#3CB4E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 16L39 11.5L34 7",
    stroke: "#3CB4E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickandarrow);
export default __webpack_public_path__ + "static/media/tickandarrow.d0148367bfa3eff82990771d4be1c7bd.svg";
export { ForwardRef as ReactComponent };